// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/common/ConfirmationModal.scss
// module id = 1303
// module chunks = 0